import React from "react";
import DcaSimulatorView from "../components/liqmap/DcaSimulatorView";

// Thin page wrapper for /liquidity-map/dca.
export default function DcaSimulatorPage() {
  return <DcaSimulatorView />;
}
